import * as React from 'react';

const PopoverIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="7" viewBox="0 0 22 7" fill="none">
    <g>
      <path
        d="M11.3703 1.66403L11 1.25588L10.6297 1.66403L1.10341 12.164L0.344972 13H1.47372H20.5263H21.655L20.8966 12.164L11.3703 1.66403Z"
        fill="white"
        stroke="#BEC0C5"
      />
    </g>
    <defs>
      <clipPath>
        <rect width="22" height="7" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default PopoverIcon;
